import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Mis hijos no lo podían creer. En una tarde imprimimos todas las figuritas y llenamos casi todo el álbum. Fue una tarde increíble en familia.',
    author: 'Marcelo R.',
    role: 'papá de 2 hijos, Buenos Aires'
  }, {
    quote: 'Soy coleccionista y el pack histórico me voló la cabeza. Tener Qatar 2022, Rusia 2018 y los demás en un solo pack es algo que no esperaba. Vale cada peso.',
    author: 'Claudia M.',
    role: 'coleccionista, Santiago'
  }, {
    quote: 'Fácil de descargar, fácil de imprimir y la calidad es excelente. Lo recomiendo 100%.',
    author: 'Diego F.',
    role: 'Montevideo'
  }];
  return <section className="py-20 bg-white" data-id="element-288">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-289">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-290">
          <h2 className="text-4xl md:text-5xl text-wc-dark mb-4" data-id="element-291">
            💬 LO QUE DICEN LOS QUE YA LO TIENEN
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-292">
          {testimonials.map((test, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-gray-50 p-8 rounded-3xl border border-gray-100 shadow-sm relative" data-id="element-293">
              <div className="flex gap-1 mb-6" data-id="element-294">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-wc-yellow" fill="currentColor" data-id="element-295" />)}
              </div>
              <p className="text-lg text-gray-700 italic mb-8 relative z-10" data-id="element-296">
                "{test.quote}"
              </p>
              <div className="mt-auto" data-id="element-297">
                <p className="font-bold text-wc-dark text-lg" data-id="element-298">{test.author}</p>
                <p className="text-sm text-gray-500" data-id="element-299">{test.role}</p>
              </div>

              <div className="absolute top-6 right-6 text-8xl text-gray-200 opacity-50 font-serif leading-none" data-id="element-300">
                "
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}